import { useMutation } from 'react-query';
import { RemoteExaminationsRepo } from '@repository/examinations/ExaminationsRepo';

const remoteExaminationsRepo = new RemoteExaminationsRepo();

const fetchExaminations = async (keyword: string) => {
  const { data } = await remoteExaminationsRepo.fetchExaminations(keyword);
  return data.examinations;
};

const fetchExaminationGrades = async (code: number) => {
  const { data } = await remoteExaminationsRepo.fetchExaminationGrades(code);
  return data.examinationGrades;
};

export default function useExaminations() {
  return useMutation((keyword: string) => fetchExaminations(keyword));
}

export function useExaminationGrades() {
  return useMutation((code: number) => fetchExaminationGrades(code));
}
